var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Motivos',{attrs:{"titulo-pagina":"Discordo do vendedor","url-api":"/refund-request/disagree/categories","mostrar-outros":false,"proxima-pagina":"/acompanhar-solicitacao-reembolso/discordar"}})}
var staticRenderFns = []

export { render, staticRenderFns }